/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Size_Run_CategoryInputs */

const en_reference_dataset_size_run_category = /** @type {(inputs: Reference_Dataset_Size_Run_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size run categories`)
};

/**
* | output |
* | --- |
* | "Size run categories" |
*
* @param {Reference_Dataset_Size_Run_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_size_run_category = /** @type {((inputs?: Reference_Dataset_Size_Run_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Size_Run_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_size_run_category(inputs)
});